import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";

const FeatureCallOutContainer = ({ featureId, clickAwayDismiss, render }) => {
  const inputEl = useRef(null);
  const [dismissed, setDismissed] = useState(false);

  const handleDismiss = () => {
    localStorage.setItem(featureId, true);
    setDismissed(true);
  };

  const handleClick = (e) => {
    if (inputEl.current.contains(e.target)) return true;
    if (clickAwayDismiss) handleDismiss();
  };

  const markAsViewed = () => {
    handleDismiss();
  };

  useEffect(() => {
    window.addEventListener("mousedown", handleClick, false);
    // will be called on component unmount
    return () => {
      window.removeEventListener("mousedown", handleClick, false);
    };
  }, []);

  const hasViewed = localStorage.getItem(featureId) || false;
  let show = !hasViewed;
  if (dismissed) show = false;

  return (
    <div className="callout" ref={inputEl}>
      {render({ show, markAsViewed })}
    </div>
  );
};

FeatureCallOutContainer.propTypes = {
  featureId: PropTypes.string.isRequired,
  clickAwayDismiss: PropTypes.bool,
};

FeatureCallOutContainer.defaultProps = {
  clickAwayDismiss: true,
};

export default FeatureCallOutContainer;
